import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBase";
import {
  IContactus,
  IGenericResponse,
  ISigninReseponseSchema,
  ISocialSignupSchema,
  IUpdatePassword,
  IUserLists,
  ActivateUser,
  DeactivateUser,
  ISubscribeNews,
  UnSubscribePayment,
  GetSubscribers,
  Deletesubscriber,
  IUpdateSetting,
  GetUserDets
} from "./types";
import { SignupInput } from "../../pages/auth/signup.page";
import { SigninInput } from "../../pages/auth/signin.page";
import { ForgotPassInput, ResetInput } from "../../pages/auth/forgot.page";
import { userApi } from "./userApi";
import { IFeedback } from "./types";
import { FeedBackForm } from "../../components/genie/TotalPanel";
import { ContactUsForm } from "../../pages/contactus.page";
import { updateSettingVal } from "../../pages/Usersetting";
import { NewsSubscriptionForm } from "../../pages/Smart_contract_landingpage";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    socialAuth: builder.mutation<
      {
        email: string; access_token: string; role: string, registered_status: string;
      },
      ISocialSignupSchema
    >({
      query(data) {
        return {
          url: "auth/social",
          method: "POST",
          body: data,
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          await dispatch(userApi.endpoints.getMe.initiate(null));
        } catch (error) { }
      },
    }),
    signupUser: builder.mutation<IGenericResponse, SignupInput>({
      query(data) {
        return {
          url: "auth/signup",
          method: "POST",
          body: data,
        };
      },
    }),
    /* signinUser: builder.mutation<ISigninReseponseSchema, SigninInput>({
      query(data) {
        return {
          url: "auth/signin",
          method: "POST",
          body: data,
          credentials: "include",
        };
      } */
    signinUser: builder.mutation<ISigninReseponseSchema, SigninInput>({
      query(data) {
        return {
          url: `auth/signin`,/* ?client_ip=${data.client_ip} */
          method: "POST",
          body: data,
          credentials: "include",
        };
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          await dispatch(userApi.endpoints.getMe.initiate(null));
        } catch (error) { }
      },
    }),
    verifyEmail: builder.mutation<IGenericResponse, { code: string }>({
      query(data) {
        return {
          url: "auth/verify",
          method: "PATCH",
          body: data,
        };
      },
    }),
    forgotPassword: builder.mutation<IGenericResponse, ForgotPassInput>({
      query(data) {
        return {
          url: "auth/forgotPass",
          method: "POST",
          body: data,
        };
      },
    }),
    ResetPassword: builder.mutation<IGenericResponse, ResetInput>({
      query(data) {
        return {
          url: "auth/resetPass",
          method: "POST",
          body: data,
        };
      },
    }),

    FeedBack: builder.mutation<IFeedback, FeedBackForm>({
      query(data) {
        return {
          url: "auth/sendFeedback",
          method: "POST",
          body: data,
        };
      },
    }),
    Contactus: builder.mutation<IContactus, ContactUsForm>({
      query(data) {
        return {
          url: "auth/contactus",
          method: "POST",
          body: data,
        };
      },
    }),

    SubscribeNews: builder.mutation<ISubscribeNews, NewsSubscriptionForm>({
      query(data) {
        return {
          url: "auth/subscribefornews",
          method: "POST",
          body: data,
        };
      },
    }),

    UnSubscribepayment: builder.mutation<UnSubscribePayment, { email: string }>({
      query({ email }) {
        return {
          url: `payment/unsubscribepayment/?email=${email}`,
          method: "POST",
        };
      },
    }),

    // UpdatePass: builder.mutation<IUpdatePassword, updatepasswordval>({
    //   query(data) {
    //     return {
    //       url: "auth/updatePass",
    //       method: "POST",
    //       body: data,
    //     };
    //   },
    // }),

    UpdateSetting: builder.mutation<IUpdateSetting, { user_image: string, social_url: string, blog_default: number, email: string, name: string }>({
      query({ user_image, social_url, blog_default, email, name }) {
        return {
          url: `auth/updateUserSettings?user_image=${user_image}&social_url=${social_url}&blog_default=${blog_default}&email=${email}&name=${name}`,
          method: "POST",
          // body: data,
        };
      },
    }),

    UsersList: builder.mutation<IUserLists, { skip: number, limit: number, from_date: string, to_date: string, search_str: string }>({
      query({ skip, limit, from_date, to_date, search_str }) {
        return {
          url: `auth/getUserList?skip=${skip}&limit=${limit}&from_date=${from_date}&to_date=${to_date}&search_str=${search_str}`,
          method: "POST",
          // body: data,
        };
      },
    }),

    getUserDetails: builder.mutation<GetUserDets, { email: string, filter: string, start_date: string, end_date: string }>({
      query({ email, filter, start_date, end_date }) {
        return {
          url: `auth/getUserDetailByEmailID?email=${email}&filter=${filter}&start_date=${start_date}&end_date=${end_date}`,
          method: "POST",
          // body: data,
        };
      },
    }),

    getUserDetailsId: builder.mutation<GetUserDets, { userid: string }>({
      query({ userid }) {
        return {
          url: `auth/getUserDetailByID?id=${userid}`,
          method: "POST",
          // body: data,
        };
      },
    }),


    DeleteSubscriber: builder.mutation<Deletesubscriber, { email: string }>({
      query({ email }) {
        return {
          url: `auth/delete_subscriber?email=${email}`,
          method: "GET",
        };
      },
    }),

    ActiveUser: builder.mutation<ActivateUser, { email: string }>({
      query({ email }) {
        return {
          url: `auth/activate_user?email=${email}`,
          method: "GET",
        };
      },
    }),

    DeactiveUser: builder.mutation<DeactivateUser, { email: string }>({
      query({ email }) {
        return {
          url: `auth/deactivate_user?email=${email}`,
          method: "GET",
        };
      },
    }),

    GetSubscribers: builder.mutation<GetSubscribers, { skip: number, limit: number, from_date: string, to_date: string, search_str: string }>({
      query({ skip, limit, from_date, to_date, search_str }) {
        return {
          url: `auth/getSubscribers?skip=${skip}&limit=${limit}&from_date=${from_date}&to_date=${to_date}&search_str=${search_str}`,
          method: "POST",
        };
      },
    }),

    contactUs: builder.mutation({
      query: (body) => ({
        url: "auth/contactus",
        method: "POST",
        body,
      }),
    }),

    getPartnerList: builder.query<any, void>({
      query: () => ({
          url: "admin/parner_list",
          method: "GET",
      }),
    }),

    updateUserAsPartnerAdmin: builder.mutation<
        any,
        { userid: string; partner: string }
    >({
        query: ({ userid, partner }) => ({
            url: `admin/update_user_as_partner_admin?userid=${userid}&partner=${encodeURIComponent(partner)}`,
            method: "POST",
        }),
    }),

    addPartner: builder.mutation<
        { status: string },
        { partner_name: string; status: number }
    >({
        query: ({ partner_name, status }) => ({
            url: `admin/add_partner?partner_name=${encodeURIComponent(partner_name)}&status=${status}`,
            method: "POST",
        }),
    }),


  }),

});

export const {
  useSocialAuthMutation,
  useSignupUserMutation,
  useSigninUserMutation,
  useVerifyEmailMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useFeedBackMutation,
  useContactusMutation,
  useUsersListMutation,
  useActiveUserMutation,
  useDeactiveUserMutation,
  useSubscribeNewsMutation,
  useGetSubscribersMutation,
  useDeleteSubscriberMutation,
  useUnSubscribepaymentMutation,
  useUpdateSettingMutation,
  useGetUserDetailsMutation,
  useGetUserDetailsIdMutation,
  useContactUsMutation,
  useGetPartnerListQuery,
  useUpdateUserAsPartnerAdminMutation,
  useAddPartnerMutation,
} = authApi;
